import { render, staticRenderFns } from "./Terreno.vue?vue&type=template&id=70137582&scoped=true&lang=html&"
import script from "./Terreno.vue?vue&type=script&lang=js&"
export * from "./Terreno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70137582",
  null
  
)

export default component.exports